import React, { useCallback } from 'react';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { Stack } from '@cp/ds/src/components/stack';
import { useRouter } from '@cp/shared/router';
import { CareerId } from '@common/const/catalog/career';
import { CatalogItemType } from '@common/model/catalog/item/type';
import useMediaQuery from '@mui/material/useMediaQuery';
import { AppTheme } from '@cp/ds';
import HeaderBase, { HeaderFeature } from 'src/widgets/header';
import { CatalogItemActions } from 'src/widgets/catalog/item/actions';

export interface HeaderProps {
  careerId?: CareerId;
  id: number;
  catalogType: CatalogItemType;
}

export const Header: React.FC<HeaderProps> = ({ id, catalogType }) => {
  const router = useRouter();
  const isMobile = useIsMobile();
  const isSmallScreen = useMediaQuery((theme: AppTheme) => theme.breakpoints.down('lg'));

  const handleReturn = useCallback(() => {
    const isHistoryEmpty = window.history.length === 1;
    if (isHistoryEmpty) {
      if (window.opener) {
        window.close();
      } else {
        router.navigate('/');
      }
    } else {
      window.history.back();
    }
  }, [router]);

  return (
    <HeaderBase
      desktopFeatures={{ [HeaderFeature.LoginButton]: false, [HeaderFeature.Favorites]: false }}
      mobileFeatures={{ [HeaderFeature.LoginButton]: false, [HeaderFeature.Favorites]: false }}
      onGoBack={isMobile ? handleReturn : undefined}
      rightBlock={
        isSmallScreen ? null : (
          <Stack direction="row" spacing={1.5}>
            <CatalogItemActions catalogType={catalogType} id={id} />
          </Stack>
        )
      }
      sticky
      sx={{ backgroundColor: 'white' }}
    />
  );
};
